import React ,{useEffect} from 'react'
import '../volunteering/Volunteering.css'
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Title_3 from "../common/common_components/Common_Title_3/Common_Title_3";
import Volunteer_Card from '../volunteering/volunteer_card/Volunteer_Card';
import Donation_card from '../common/common_components/donation-card/Donation_card';
import { AllDonation } from '../../features/admin/donation/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from "../../utils/IDS";
const Donate = () => {


   const dispatch = useDispatch();

  const all_donation = useSelector((state) => state.donation.all_donation);
  
  useEffect(() => {
    dispatch(AllDonation());
  }, [dispatch]);



    const breadcrumbs = [
        { label: "EXPLORE", link: "/explore", active: false },
        {
            label: "DONATION",
            link: "",
            active: true,
        },
    ];


    return (
        <>
            <section className="Volunteering">
                <div className="container">
                    <div className="breadcrump_div">
                        <Breadcrumb_Comp data={breadcrumbs} />
                    </div>

                    <div className="main_content_div">
                        <Common_Title_3 titleText="Donations" hideSeeAll={true} />

                        <div className="row">
                            {all_donation?.map((item, index) => {
                                return (
                                    <div className="col-12 mb-4" key={index}>
                                        {/* <Volunteer_Card /> */}
                                        <Donation_card item={item}/>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Donate